// extracted by mini-css-extract-plugin
export default {"constrolesInput__leble":"ControlesInput_constrolesInput__leble__FdByp","constrolesInput__input":"ControlesInput_constrolesInput__input__CVtKp"};